// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__iebAs","range":"MonthRangeSwitch_range__3-cnH","disabled":"MonthRangeSwitch_disabled__3n4Ol"};